import { Component, Input } from '@angular/core';

@Component({
    selector: 'app-spinner',
    templateUrl: './spinner.component.html',
    styleUrls: [ './spinner.component.scss' ]
})

export class SpinnerComponent {
    @Input('text') text;
}



// WEBPACK FOOTER //
// ./src/app/shared/components/spinner.component.ts